//page-1
export const endpoints = {
  getIndustryList: `IndustryUsecases`,//Changed
  companyDetails: {
    checkAccessURLInstance: "CheckAvailability",//Changed
    detailsSubmit: "CreateInstance",//Changed
    instanceStatusCheck: "InstanceStatus",//Changed
    tenantType:"RoleArnFetch",//Changed
    updateTenantTable:"UpdateTenancy",//Changed
    launchStack:"RapidConnect_STSAttachPolicy",
    yourAccount:"keyGenerator"//adde
  },
  othersDetails: {
    detailsSubmit: "OtherForm",//Changed
  },

  //page-2
  claimPhoneNumber: {
    getCountryList: "CountriesList",//Changed
    claim: "SearchAvailablePhoneNumbers",//Changed
    claimNumber: "ClaimPhoneNumber",//Changed
    bucketCreationSKPIAnalytics:"BucketCreation",//Changed
    instanceStorageConfig:'InstanceStorageConfig'//Updated
  },

  //page-3
  adminDetails: {
    detailsSubmit: "AddAdministrator",//Changed
    allowChatSubmit: "CreateBot",//Changed
    allowChatEmail: "AllowchatbotSes",//Changed
    agentActivity: "AgentActivity",//Changed
    ctr : "CtrSkpi",//Changed
    realTimeMetrics: "RealtimeMetricsSkpi",//Changed
  },

  //page-4
  selectQueues: {
    getCountryTimeZoneList: `TimeZones`,//Changed
    customPromptHandling: "CustomPrompt",//Changed
    createContactFlow: "CreateContactFlow",//needToUpdate
    createHOPQueue: "CreatingHoursOfOperationAndQueues",//needToUpdate
    addIntents: "AddIntents",//Changed
    voiceMailHandling: "VoicemailSes",//Changed
    buildBot: "BuildBot",//Changed
    contactFlowLogsSKPI:"contactFlowLogsSKPI",//Added
    LexlogosSKPI:"lexLogsSkpi",//Added
    callRecording:"BucketRetention"//Changed
  },

  //page-5
  agentDetails: {
    detailsSubmit: "AddAgentsManually",//Changed
    csvTemplateDownload : "rapidconnectbulkusers/User_management_ 1.csv",//NeedToChangeBucketName
    csvTemplateUpload: "uploadCsv",//Changed
    bulkUsersCreation: "bulk_users",//Changed
  },

  //page-6
  salesForceDetails: {
    detailsSubmit: "SalesforceIntegration",//Changed
  },
 
  //Last-Page
  successPage: {
    successMail: "SuccessMail",//Changed
    detachPolicy:"RapidConnect_STSDetachPolicy"
  },

  //error-logs
  errorLoggers: "ErrorLogs",//Changed
};
